import styled from "styled-components";

export const TransactionsStyled = styled.div `
`;

export const TransactionsFilterPresets = styled.div `
    display: flex;
    flex-direction: row;
    gap: 8px;
    cursor: pointer;
    
    div {
        border-bottom: 1px dotted var(--color-main);
    }
`;
